<div class="row my-4">

    <ng-container *ngFor="let a of alerts">
        <div class="col-lg-4 col-print-4 col-12 col-sm-6 py-md-2 py-1 px-sm-0 d-flex align-items-end">
            <div class="hex bg-success" [ngClass]="{'bg-warning': a.qtd > 0 }">
                <span [style.lineHeight]="1.05"
                [ngClass]="{ 'f-md-24 f-16': a.qtd > 99 && a.qtd <= 999, 'rounded bg-warning f-16': a.qtd > 999 }"> {{ a.qtd }} </span>
            </div>
            <div>
                <span class="fw-500 px-1 text-success" [ngClass]="{'text-warning': a.qtd>0 }">{{a.label}}
                    <span *ngIf="a.total && a.total!='Sem detalhamento'"> - R$ {{ a.total }} </span>
                </span>
            </div>
        </div>
    </ng-container>

</div>